(ns lupapalvelu.ui.auth-admin.building-data-source.core
  (:require [lupapalvelu.next.event :refer [<sub >evt]]
            [lupapalvelu.ui.auth-admin.building-data-source.subs :as subs]
            [lupapalvelu.ui.common :as common]
            [lupapalvelu.ui.dom :as ui-dom]
            [lupapalvelu.ui2.button :as button]
            [lupapalvelu.ui2.radio :as radio]))

(def data-sources
  [{:value       :kuntagml
    :label       :auth-admin.building-data-source.kuntagml.label
    :description :auth-admin.building-data-source.kuntagml.description}
   {:value       :ryhti
    :label       :auth-admin.building-data-source.ryhti.label
    :description :auth-admin.building-data-source.ryhti.description}])

(defn- source-option
  [{:keys [value label description disabled?]}]
  [:div.flex.flex-col.gap-3
   [radio/radio
    {:disabled disabled?
     :value    value}
    [:span.flex.flex-col.gap-1
     [:span.font-semibold (common/loc label)]
     [:span.text-sm.text-text-muted (common/loc description)]]]])

(defn view []
  (let [current-building-data (<sub [::subs/current-building-data-config])
        ;; todo lpk-8572 we probably need to show this even if no ryhti configuration
        ;; so we can configure municipality system credentials
        ryhti-api-configured? (<sub [::subs/ryhti-api-configured?])]
    (when (and ryhti-api-configured? current-building-data)
      [:section.nobase.twp.lp-theme.flex.flex-col.gap-4.py-6
       [:div.flex.flex-col.gap-1
        [:h2.text-xl.font-bold (common/loc :auth-admin.building-data-source.title)]
        [:p.text-sm.text-text-muted
         (common/loc :auth-admin.building-data-source.description)]]
       (into [radio/radio-group
              {:aria-label      (common/loc :auth-admin.building-data-source.title)
               :class           ["flex" "flex-col" "gap-3"]
               :value           (:source current-building-data)
               :on-value-change #(>evt [::subs/change-source (keyword %)])}]
             (map source-option data-sources))
       [button/button
        {:class    ["self-start"]
         :disabled (<sub [::subs/save-disabled?])
         :on-click #(>evt [::subs/save])}
        (common/loc :save)]])))

(defonce mounter (ui-dom/init :reagent (constantly view)))

(defn ^:export start [dom-id]
  (ui-dom/mount! mounter dom-id))
